/* Banky Nieuw WP6.3: rekenhulp op de productpagina (sections/banky-charge-calculator.liquid, PLAN.md #70).
   De uitkomsten staan al per toestel in de HTML (data-aantal op elke <option>, vooraf berekend met A's rekenmodel door
   scripts/build_charge_compare_data.py); dit script rekent dus niets, het toont alleen de gekozen uitkomst:
   "tot circa 4,5x" met de toestelnaam en de batterijbolletjes, of bij een laptop met te weinig vermogen de melding
   met beide wattages. Laptopregel met G13 (01-10-2026): een uitkomst "m1,5" is minimaal vermogen, dus het aantal plus
   de melding "Minimaal vermogen" met beide wattages. Teksten komen uit de locale (data-tekst-* op de sectie).
   De keuze blijft bewaard in localStorage (banky.toestel.v1), zodat elke productpagina meteen jouw toestel toont, en
   gaat als event banky:toestel naar de vergelijktabel (banky-product-compare.js), zodat die dezelfde toestelrij toont.
   Zonder JavaScript staat de uitkomst voor het standaardtoestel in de HTML. */
(() => {
  if (window.bankyRekenhulp) return;
  window.bankyRekenhulp = true;
  const SLEUTEL = 'banky.toestel.v1';
  const MAX = 12;
  const lees = () => { try { return window.localStorage.getItem(SLEUTEL); } catch (e) { return null; } };
  const bewaar = w => { try { window.localStorage.setItem(SLEUTEL, w); } catch (e) { /* privé venster: niet bewaren */ } };
  const vul = (sjabloon, waarden) => Object.keys(waarden).reduce((t, k) => t.split('[' + k + ']').join(waarden[k]), sjabloon || '');
  // Reviewronde r7: de zin loopt door achter het getal ("tot circa 4x je iPhone 15 opladen"); breekt hij, dan niet midden in een korte
  // toestelnaam ("je iPhone / 15 opladen" op 360 en 375px). Een naam tot en met 20 tekens krijgt harde spaties (blijft heel, zoals in
  // banky-charge-calculator.liquid); een langere naam breekt alleen tussen de delen: merk en eerste woord, het getal met "inch", alles
  // tussen haakjes en de laatste twee woorden blijven bij elkaar ("MacBook Pro 16 inch (M5 Pro of M5 Max)").
  const heel = t => t.length <= 20 ? t.replace(/ /g, '\u00a0')
    : t.replace(/\([^)]*\)/g, m => m.replace(/ /g, '\u00a0')).replace(/ (?=inch\b)/g, '\u00a0').replace(/^(\S+) /, '$1\u00a0').replace(/ (\S+)$/, '\u00a0$1');

  function bolletjes(doel, aantal) {
    const n = Number(String(aantal).replace(',', '.'));
    doel.textContent = '';
    if (!(n > 0)) return;
    const heel = Math.ceil(n);
    for (let i = 0; i < Math.min(Math.max(heel, 1), MAX); i++) {
      const b = document.createElement('span');
      b.className = 'banky-rekenhulp__bolletje';
      b.style.setProperty('--banky-vulling', String(Math.round(Math.max(0, Math.min(1, n - i)) * 100) / 100));
      doel.appendChild(b);
    }
    if (heel > MAX) {
      const meer = document.createElement('span');
      meer.className = 'banky-rekenhulp__meer';
      meer.textContent = '+' + (heel - MAX);
      doel.appendChild(meer);
    }
  }

  function toon(blok) {
    const keuze = blok.querySelector('[data-banky-rekenhulp-toestel]');
    const optie = keuze && keuze.selectedOptions[0];
    if (!optie) return;
    const d = blok.dataset;
    const toestel = optie.textContent.trim();
    const waarde = optie.dataset.aantal || '';
    const minimaal = waarde.charAt(0) === 'm';
    const aantal = minimaal ? waarde.slice(1) : waarde;
    const resultaat = blok.querySelector('[data-banky-rekenhulp-resultaat]');
    const melding = blok.querySelector('[data-banky-rekenhulp-melding]');
    if (aantal === 't') {
      blok.querySelector('[data-banky-rekenhulp-melding-titel]').textContent = vul(d.tekstWeinigTitel, {toestel});
      const sjabloon = optie.dataset.drempelSoort === 'adapter' ? d.tekstWeinigAdapter : d.tekstWeinigMin;
      blok.querySelector('[data-banky-rekenhulp-melding-tekst]').textContent = vul(sjabloon, {vermogen: d.vermogen, toestel, nodig: optie.dataset.drempel || ''});
      const elders = blok.querySelector('[data-banky-rekenhulp-elders]');
      if (elders) elders.hidden = !optie.hasAttribute('data-elders');
      resultaat.hidden = true;
      melding.hidden = false;
      return;
    }
    blok.querySelector('[data-banky-rekenhulp-aantal]').textContent = vul(d.tekstAantal, {aantal});
    blok.querySelector('[data-banky-rekenhulp-wat]').textContent = vul(minimaal && d.tekstEnergiereserve ? d.tekstEnergiereserve : d.tekstWat, {toestel: heel(toestel)});
    bolletjes(blok.querySelector('[data-banky-rekenhulp-bolletjes]'), aantal);
    const minimaalBlok = blok.querySelector('[data-banky-rekenhulp-minimaal]');
    if (minimaalBlok) {
      if (minimaal) {
        const sjabloon = optie.dataset.drempelSoort === 'adapter' ? d.tekstMinimaalAdapter : d.tekstMinimaalMin;
        minimaalBlok.querySelector('[data-banky-rekenhulp-minimaal-tekst]').textContent = vul(sjabloon, {vermogen: d.vermogen, nodig: optie.dataset.drempel || ''});
      }
      minimaalBlok.hidden = !minimaal;
    }
    melding.hidden = true;
    resultaat.hidden = false;
  }

  // Vertel de rest van de pagina (vergelijktabel) welk toestel gekozen is.
  function meld(keuze) {
    const o = keuze.selectedOptions[0];
    if (!o) return;
    document.dispatchEvent(new CustomEvent('banky:toestel', {detail: {index: Number(o.dataset.index), naam: o.textContent.trim(), groep: o.dataset.groep || ''}}));
  }

  function start(blok) {
    if (blok.dataset.bankyRekenhulpKlaar) return;
    blok.dataset.bankyRekenhulpKlaar = '1';
    // Laadgloed van de bolletjes (Geert 05-10-2026, ronde 7: "ook de bars net zoals op de main pagina dezelfde laad gloed animatie geven";
    // CSS in assets/banky-pagina-product.css): alleen zolang de rij in beeld is staat data-laadt erop, zodat de browser buiten beeld niet
    // elk beeld blijft tekenen (reviewronde r7, gemeten: 60 tekenrondes per seconde op de hele productpagina). Zelfde patroon als de
    // batterij-iconen op de home (banky-sales.js, blok "Laadgloed"). Zonder IntersectionObserver loopt hij gewoon.
    const rij = blok.querySelector('[data-banky-rekenhulp-bolletjes]');
    if (rij) {
      if ('IntersectionObserver' in window) new IntersectionObserver(es => { for (const e of es) rij.toggleAttribute('data-laadt', e.isIntersecting); }).observe(rij);
      else rij.setAttribute('data-laadt', '');
    }
    const keuze = blok.querySelector('[data-banky-rekenhulp-toestel]');
    if (!keuze) return;
    const bewaard = lees();
    if (bewaard && bewaard !== keuze.value && [...keuze.options].some(o => o.value === bewaard)) {
      keuze.value = bewaard;
      toon(blok);
      meld(keuze);
    }
    keuze.addEventListener('change', () => { bewaar(keuze.value); toon(blok); meld(keuze); });
  }

  const alles = () => document.querySelectorAll('[data-banky-rekenhulp]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  // Shopify-thema-editor en section rendering: opnieuw koppelen als de sectie opnieuw geladen wordt.
  document.addEventListener('shopify:section:load', alles);
})();
